import { MainHeader, Section, SectionParagraph } from '@/components/shared/Content';
import { Flex } from '@lemonade-hq/cdk';
import parse from 'html-react-parser';
import type React from 'react';

export interface HeroProps {
  title: string;
  subtitle: string;
}

export const Hero: React.FC<React.PropsWithChildren<HeroProps>> = ({ title, subtitle, children }) => {
  return (
    <Section px="20px">
      <Flex flexDirection="column" gap="20px" alignItems="center">
        <MainHeader>{parse(title)}</MainHeader>
        <SectionParagraph>{parse(subtitle)}</SectionParagraph>
      </Flex>
      {children}
    </Section>
  );
};
